import { storeService } from '@/services';
import StoreVM from '@/view-model/store-management/StoreVM';
export default {
    resetVirtualBanksByStore({ commit }) {
        commit('RESET_VIRTUAL_BANKS_BY_STORE');
    },
    resetStoreDetail({ commit }) {
        commit('RESET_STORE_DETAIL');
    },
    async getVirtualBanksByStore({ commit }, code) {
        const response = await storeService.getVirtualBanksByStore({
            storeId: code,
        });
        commit('GET_STORE_VIRTUAL_BANK_LIST', response.data);
    },
    async getStoreDetail({ commit }, code) {
        const response = await storeService.getStoreDetail(code);
        const res = new StoreVM(response.data);
        commit('GET_STORE_DETAIL', res);
    },
};
